import React, { Component } from 'react';
import withStyles from '@material-ui/styles/withStyles';
import * as _ from 'lodash';

import Button from '@material-ui/core/Button';

import Fab from '@material-ui/core/Fab';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

import Grid from '@material-ui/core/Grid';

import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import DeleteIcon from '@material-ui/icons/Delete';
import PlaylistAddIcon from '@material-ui/icons/PlaylistAdd';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import InfoIcon from '@material-ui/icons/Info';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import Tooltip from '@material-ui/core/Tooltip';

import Chip from '@material-ui/core/Chip';
import categoryImages from '../images/categories';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

//**** */

import MobileStepper from '@material-ui/core/MobileStepper';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import SwipeableViews from 'react-swipeable-views';

/******* */
//const productsOnSale = [6089];
const styles = (theme) => ({
    checkoutButton: {
        backgroundColor: '#669e6f',
        color: '#fff',
        '&:hover': {
            backgroundColor: '#fff',
            color: '#669e6f',
        },
    },
    onSale: { backgroundColor: '#db0030', color: '#fff', marginLeft: '1rem' },
});

function n2l(num, unit = '') {
    if (num !== undefined) {
        try {
            if (typeof num === 'string') {
                return parseFloat(num).toLocaleString(navigator.language, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' ' + unit;
            }
        } catch (err) {}
        return num.toLocaleString(navigator.language, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' ' + unit;
    } else {
        return '';
    }
}

export function dateToLocaleWithYear(date) {
    return new Date(date).toLocaleDateString('es-ES', { day: 'numeric', month: 'long', year: 'numeric' });
}

export function dateToLocale(date) {
    return new Date(date).toLocaleDateString('es-ES', { day: 'numeric', month: 'long' });
}

class CategoriesNavigationInternal extends Component {
    render() {
        return (
            <>
                <Grid container spacing={2} justify="space-evenly">
                    {this.props.categories &&
                        this.props.categories.map((c) => (
                            <Grid item key={c}>
                                <div className="category-tile" onClick={() => this.props.onShowCategory(c)}>
                                    <div className="category-tile-image" style={{ backgroundImage: `url(${categoryImages[c]})` }}></div>
                                    <div className="category-tile-title">
                                        <span>{c}</span>
                                    </div>
                                </div>
                            </Grid>
                        ))}
                </Grid>
            </>
        );
    }
}
export const CategoriesNavigation = withStyles(styles)(CategoriesNavigationInternal);

class CategoryProductsNavigationInternal extends Component {
    constructor(props) {
        super(props);

        let processedProducts = {};
        for (let p of this.props.products) {
            if (processedProducts[p.id] !== undefined) {
                if (processedProducts[p.id].grouped !== undefined) {
                    processedProducts[p.id].grouped.push(p);
                } else {
                    processedProducts[p.id] = { id: p.id, name: p.name, grouped: [processedProducts[p.id], p] };
                }
            } else {
                processedProducts[p.id] = p;
            }
        }
        this.state = {
            expanded: [],
            products: Object.values(processedProducts),
            productDetails: undefined,
        };
    }

    handleProductExpand = (productId) => {
        let expanded = _.cloneDeep(this.state.expanded);
        expanded.push(productId);
        this.setState({ expanded: _.uniq(expanded) });
        //this.setState({ expanded: [productId] });
    };

    handleProductCollapse = (productId) => {
        let expanded = _.cloneDeep(this.state.expanded);
        let index = expanded.indexOf(productId);
        if (index !== -1) {
            expanded.splice(index, 1);
        }
        this.setState({ expanded });
    };

    handleShowInfo = (productId, cut, format) => {
        console.log(this.props.products);
        for (let p of this.props.products) {
            if (p.id === productId && p.cut === cut && p.format === format) {
                this.setState({ productDetails: p });
                break;
            }
        }
    };

    handleCloseProductDetails = () => {
        this.setState({ productDetails: undefined });
    };

    render() {
        return (
            <>
                <div className="product-nav-container">
                    <Button onClick={this.props.onCloseCategory} color="primary" variant="contained" startIcon={<ArrowBackIosIcon />}>
                        Ver catálogo productos
                    </Button>
                    <br />
                    <br />
                    {/* <img src={oferta} style={{ width: '100%', height: 'auto' }} alt="Oferta" /> */}
                    <div className="product-nav-title">{this.props.category}</div>
                    <table className="product-nav">
                        <thead>
                            <tr>
                                <th>DESCRIPCIÓN ARTÍCULO</th>
                                {!this.props.smartphone && <th style={{ textAlign: 'center' }}>INFO</th>}
                                {!this.props.smartphone && <th className="product-nav-price">PRECIO KG</th>}
                                <th className="product-nav-price">PRECIO {!this.props.smartphone ? 'UD' : ''}</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.products &&
                                this.state.products.map((p, i) => (
                                    <>
                                        {this.state.expanded.indexOf(p.id) === -1 && (
                                            <tr>
                                                <td>
                                                    {p.id} {p.name} {n2l(p.gr, 'KG')} {p.cut} {p.format}{' '}
                                                    {this.props.productsOnSale.indexOf(p.id) !== -1 && <Chip label="¡Oferta!" className={this.props.classes.onSale} />}
                                                    {this.props.smartphone && p.grouped === undefined && (
                                                        <Tooltip title="Información">
                                                            <IconButton size="small" onClick={() => this.handleShowInfo(p.id, p.cut, p.format)}>
                                                                <InfoOutlinedIcon color="primary" fontSize="1rem" />
                                                            </IconButton>
                                                        </Tooltip>
                                                    )}
                                                </td>
                                                {!this.props.smartphone && p.grouped === undefined ? (
                                                    <td style={{ textAlign: 'center' }}>
                                                        <Tooltip title="Información">
                                                            <IconButton size="medium" onClick={() => this.handleShowInfo(p.id, p.cut, p.format)}>
                                                                <InfoOutlinedIcon color="primary" fontSize="1rem" />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </td>
                                                ) : (
                                                    !this.props.smartphone && <td></td>
                                                )}
                                                {!this.props.smartphone && <td className="product-nav-price">{p.priceKg !== undefined ? `${n2l(p.priceKg)} €` : ''}</td>}
                                                <td className="product-nav-price">{p.price !== undefined ? `${n2l(p.price)} €` : ''}</td>

                                                <td>
                                                    {p.grouped &&
                                                        (true ? (
                                                            <Tooltip title="Ver opciones">
                                                                <IconButton size="medium" onClick={() => this.handleProductExpand(p.id)}>
                                                                    <PlaylistAddIcon fontSize="large" />
                                                                    {/* <ArrowDropDownIcon fontSize="large" /> */}
                                                                </IconButton>
                                                            </Tooltip>
                                                        ) : (
                                                            <Button
                                                                onClick={() => this.handleProductExpand(p.id)}
                                                                color="secondary"
                                                                variant="contained"
                                                                style={{ marginTop: '0.5rem', marginBottom: '0.5rem' }}
                                                            >
                                                                Ver opciones
                                                            </Button>
                                                        ))}
                                                    {p.grouped === undefined && (
                                                        <IconButton size="medium" style={{ color: '#000' }} onClick={() => this.props.onAddToCart(p)}>
                                                            <AddShoppingCartIcon fontSize="large" />
                                                        </IconButton>
                                                    )}
                                                </td>
                                            </tr>
                                        )}
                                        {this.state.expanded.indexOf(p.id) !== -1 && (
                                            <>
                                                <tr className={'product-nav-expanded-row-product'}>
                                                    <td>
                                                        {p.id} {p.name}
                                                        {this.props.productsOnSale.indexOf(p.id) !== -1 && <Chip label="¡Oferta!" className={this.props.classes.onSale} />}
                                                    </td>
                                                    {!this.props.smartphone && <td></td>}
                                                    {!this.props.smartphone && <td className="product-nav-price">{p.priceKg !== undefined ? `${n2l(p.priceKg)} €` : ''}</td>}
                                                    <td className="product-nav-price">{p.price !== undefined ? `${n2l(p.price)}} €` : ''}</td>

                                                    <td>
                                                        <IconButton size="medium" onClick={() => this.handleProductCollapse(p.id)}>
                                                            <ArrowDropUpIcon fontSize="large" />
                                                        </IconButton>
                                                    </td>
                                                </tr>
                                                {p.grouped.map((gp, i) => (
                                                    <tr className={i !== p.grouped.length - 1 ? 'product-nav-expanded-row' : 'product-nav-expanded-row-last'}>
                                                        <td>
                                                            {n2l(p.gr, 'KG')} {gp.cut} {gp.format}{' '}
                                                            {this.props.smartphone && (
                                                                <Tooltip title="Información">
                                                                    <IconButton size="small" onClick={() => this.handleShowInfo(gp.id, gp.cut, gp.format)}>
                                                                        <InfoOutlinedIcon color="primary" fontSize="1rem" />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            )}
                                                        </td>
                                                        {!this.props.smartphone ? (
                                                            <td style={{ textAlign: 'center' }}>
                                                                <Tooltip title="Información">
                                                                    <IconButton size="medium" onClick={() => this.handleShowInfo(gp.id, gp.cut, gp.format)}>
                                                                        <InfoOutlinedIcon color="primary" fontSize="1rem" />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            </td>
                                                        ) : (
                                                            !this.props.smartphone && <td></td>
                                                        )}
                                                        {!this.props.smartphone && <td className="product-nav-price">{n2l(gp.priceKg)} €</td>}
                                                        <td className="product-nav-price">{n2l(gp.price)} €</td>

                                                        <td>
                                                            <IconButton size="medium" style={{ color: '#000' }} onClick={() => this.props.onAddToCart(gp)}>
                                                                <AddShoppingCartIcon fontSize="large" />
                                                            </IconButton>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </>
                                        )}
                                    </>
                                ))}
                        </tbody>
                    </table>
                </div>

                <Dialog open={this.state.productDetails !== undefined} onClose={this.handleCloseProductDetails} maxWidth={'sm'} fullScreen={this.props.smartphone}>
                    <DialogTitle>Información de producto</DialogTitle>
                    <DialogContent>
                        {this.state.productDetails && (
                            <DialogContentText style={{ color: '#000' }}>
                                <b>Producto:</b> {this.state.productDetails.id} {this.state.productDetails.name}
                                <br />
                                {/* {this.state.productDetails.format && this.state.productDetails.format !== '' && (
                                    <>
                                        <b>Formato:</b> {this.state.productDetails.format}
                                        <br />
                                    </>
                                )}
                                {this.state.productDetails.cut && this.state.productDetails.cut !== '' && (
                                    <>
                                        <b>Corte:</b> {this.state.productDetails.cut}
                                        <br />
                                    </>
                                )} */}
                                {this.state.productDetails.gr && (
                                    <>
                                        <b>Peso:</b> {n2l(this.state.productDetails.gr, 'kg')}
                                        <br />
                                    </>
                                )}
                                <b>Precio (IVA incl.):</b> {n2l(this.state.productDetails.price)} €
                                <br />
                                <b>IVA:</b> {n2l(this.state.productDetails.tax)} %
                                <br />
                                {this.state.productDetails.ingredients && (
                                    <>
                                        <b>Ingredientes:</b> {this.state.productDetails.ingredients}
                                        <br />
                                    </>
                                )}
                                {this.state.productDetails.nutrition && (
                                    <>
                                        <b>Información nutricional por 100g:</b> {processNutritionalInfo(this.state.productDetails.nutrition)}
                                        <br />
                                    </>
                                )}
                                {this.state.productDetails.allergens && (
                                    <>
                                        <b>Información alérgenos:</b> {this.state.productDetails.allergens}
                                        <br />{' '}
                                    </>
                                )}
                                {this.state.productDetails.storeConditions && (
                                    <>
                                        <b>Información de conservación:</b> {this.state.productDetails.storeConditions}
                                    </>
                                )}
                            </DialogContentText>
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleCloseProductDetails} color="primary">
                            Aceptar
                        </Button>
                    </DialogActions>
                </Dialog>
            </>
        );
    }
}
export const CategoryProductsNavigation = withStyles(styles)(CategoryProductsNavigationInternal);

const processNutritionalInfo = (info) => {
    try {
        let titles = ['Sal:', 'Proteínas:', 'de los cuales azúcares:', 'Hidratos de carbono:', 'de las cuales saturadas:', 'Grasas:', 'Valor energético:'];
        let remainingInfo = info;
        let components = {};
        for (let i = 0; i < titles.length; i++) {
            const t = remainingInfo.split(titles[i]);
            if (t.length > 1) {
                remainingInfo = t[0];
                let value = t[1].trim();
                if (value.charAt(value.length - 1) === ',') {
                    value = value.substring(0, value.length - 1);
                }
                const key = titles[i].replace(':', '');

                components[key] = value;
            }
        }
        return (
            <table className="product-nutrition-table">
                <tbody>
                    {Object.keys(components)
                        .reverse()
                        .map((k, i) => (
                            <tr key={i}>
                                <td style={{ paddingLeft: k.indexOf('de l') !== -1 ? '1rem' : undefined }}>
                                    <strong>{k}</strong>
                                </td>
                                <td>{components[k]}</td>
                            </tr>
                        ))}
                </tbody>
            </table>
        );
    } catch (err) {
        return info;
    }
};

class ShoppingCartInternal extends Component {
    getMidnight = (day) => {
        const date = new Date(day);
        date.setMilliseconds(999);
        date.setSeconds(59);
        date.setMinutes(59);
        date.setHours(23);
        return date;
    };

    isDayAfterTomorrow = (date) => {
        console.log('Date', date);
        const oneDay = 1000 * 60 * 60 * 24;
        const midnightTomorrow = this.getMidnight(new Date(Date.now() + oneDay));

        return date > midnightTomorrow;
    };
    checkAvailable48h = (product) => {
        if (product.min48hPreparation === true) {
            // Adjust time diff
            return this.isDayAfterTomorrow(new Date(this.props.deliveryDate));
        }
        return true;
    };

    render() {
        return (
            <>
                {this.props.onCloseCart && (
                    <div className="cart-back-button">
                        <Button onClick={this.props.onCloseCart} color="primary" variant="contained" startIcon={<ArrowBackIosIcon />}>
                            Ver catálogo productos
                        </Button>
                    </div>
                )}
                <div className="cart-table-title">Tu pedido</div>
                <span className="cart-table-place">
                    {this.props.storePickUp === true
                        ? `Recoger en tienda entre ${this.props.deliveryTime.rangeStart} y las ${this.props.deliveryTime.rangeEnd}`
                        : `Entregar en ${this.props.customer.postalCode} ${this.props.customer.city}`}
                </span>
                <br />
                <span className="cart-table-date">{dateToLocaleWithYear(this.props.deliveryDate)}</span>
                <br />
                <table className="cart-table">
                    <tbody>
                        {this.props.cart.map((p, i) => (
                            <tr>
                                <td key={i}>
                                    <strong>{p.name}</strong>
                                    {(p.cut !== undefined || p.format) && <br />}
                                    {n2l(p.gr, 'KG')} {p.cut} {p.format}
                                    {!this.checkAvailable48h(p) && (
                                        <>
                                            <br />
                                            <span className="cart-table-48h">Solamente disponible en 48h</span>
                                        </>
                                    )}
                                </td>

                                {!this.props.smartphone && <td style={{ textAlign: 'right' }}>{n2l(p.price)} €</td>}
                                <td className="cart-table-quantity">
                                    <IconButton size="small" disabled={!this.checkAvailable48h(p)} onClick={() => this.props.onRemoveProduct(p, 1)}>
                                        <RemoveIcon fontSize="inherit" />
                                    </IconButton>
                                    {p.quantity}
                                    <IconButton size="small" disabled={!this.checkAvailable48h(p)} onClick={() => this.props.onAddProduct(p)}>
                                        <AddIcon fontSize="inherit" />
                                    </IconButton>
                                </td>
                                <td className="cart-table-price">{n2l(p.amount)} €</td>
                                <td>
                                    <IconButton size="small" color="primary" onClick={() => this.props.onRemoveProduct(p)}>
                                        <DeleteIcon fontSize="inherit" />
                                    </IconButton>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                {this.props.storePickUp === false && (
                    <div className="cart-shipment-costs">
                        {/* <span style={{ float: 'left' }}>Situación COVID-19</span> */}
                        <span style={{ float: 'right' }}>
                            Costes de transporte <strong>0 €</strong>
                        </span>
                    </div>
                )}
                <div className="cart-total">
                    <div className="cart-total-label">
                        <Tooltip title="El peso de cada uno de los artículos es aproximado por lo que el total puede variar sensiblemente">
                            <InfoIcon fontSize="1rem" style={{ marginRight: '5px' }} />
                        </Tooltip>
                        <div>
                            Total aproximado
                            <br />
                            <span style={{ fontSize: '0.8rem', color: 'grey' }}>IVA incluido</span>
                        </div>
                    </div>
                    <span>{n2l(this.props.amount)} €</span>
                </div>
                {this.props.checkOutDisabled === undefined && this.props.cart.length > 0 && (
                    <div className="cart-checkout-button-container">
                        {this.props.amount < 50 && this.props.storePickUp === false && <span className="cart-checkout-error-message">El pedido mínimo es de 50€</span>}
                        {this.props.cart.some((p) => !this.checkAvailable48h(p)) && (
                            <span className="cart-checkout-error-message">
                                Tiene artículos que requieren 48h de preparación.
                                <br />
                                Cambie la fecha de entrega o elimine los productos de la cesta.
                            </span>
                        )}
                        <Button
                            classes={{ contained: this.props.classes.checkoutButton }}
                            disabled={(this.props.amount < 50 && this.props.storePickUp === false) || this.props.cart.some((p) => !this.checkAvailable48h(p))}
                            fullWidth
                            size="large"
                            onClick={this.props.onCheckout}
                            variant="contained"
                        >
                            Comprar
                        </Button>
                    </div>
                )}
                <div className="approximate-price-disclamer-pop-up">
                    <strong>Todos nuestros precios son aproximados</strong>
                    <br />
                    El nuestro es un trabajo artesanal realizado por nuestros carniceros, y por tanto, el precio de las bandejas puede variar según el tipo de corte o el tamaño de producto.
                    <br /> <br />
                    <strong>Todos nuestros precios incluyen IVA</strong>
                </div>
            </>
        );
    }
}
export const ShoppingCart = withStyles(styles)(ShoppingCartInternal);

class HighlightedProductsInternal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeStep: 0,
        };
    }

    handleNext = () => {
        this.setState({ activeStep: Math.min(this.state.activeStep + 1, this.props.products.length - 1) });
    };

    handleBack = () => {
        this.setState({ activeStep: Math.max(this.state.activeStep - 1, 0) });
    };

    handleStepChange = (step) => {
        this.setState({ activeStep: step });
    };
    render = () => {
        const activeStep = this.state.activeStep;
        // const maxSteps = this.props.products.length;
        let imageStyle = {};
        if (this.props.smartphone) {
            imageStyle.height = window.innerHeight - 48 - 8;
        }

        let repeatedIds = [];
        let uniqueProducts = [];
        // TODO: Improve this! avoid repeated ids
        for (let p of this.props.products) {
            if (repeatedIds.indexOf(p.id) === -1) {
                repeatedIds.push(p.id);
                uniqueProducts.push(p);
            }
        }
        const maxSteps = uniqueProducts.length;

        return (
            <div className="highlighted-products-container ">
                {this.props.smartphone && (
                    <div className="highlighted-products-back-container">
                        <Button onClick={this.props.onClose} color="secondary" variant="contained" endIcon={<CloseIcon color="primary" />}>
                            Cerrar ofertas
                        </Button>
                    </div>
                )}
                <div className="highlighted-products-add-to-cart">
                    <Fab color="primary" aria-label="Añadir al carrito" onClick={() => this.props.onAddToCart(uniqueProducts[activeStep] /*this.props.products[activeStep]*/)}>
                        <AddShoppingCartIcon color="secondary" />
                    </Fab>
                </div>
                <SwipeableViews axis={'x'} index={this.state.activeStep} onChangeIndex={this.handleStepChange} enableMouseEvents>
                    {uniqueProducts.map((p, index) => (
                        <div key={p.name} className="highlighted-products-img" style={{ ...imageStyle, ...{ backgroundImage: `url(${p.imageUrl})` } }}></div>
                    ))}
                </SwipeableViews>
                <MobileStepper
                    steps={maxSteps}
                    position="static"
                    variant="dots"
                    activeStep={activeStep}
                    nextButton={
                        <Button size="small" onClick={this.handleNext} disabled={activeStep === maxSteps - 1}>
                            <KeyboardArrowRight />
                        </Button>
                    }
                    backButton={
                        <Button size="small" onClick={this.handleBack} disabled={activeStep === 0}>
                            <KeyboardArrowLeft />
                        </Button>
                    }
                />
            </div>
        );
    };
}
export const HighlightedProducts = withStyles(styles)(HighlightedProductsInternal);
